module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAABVQTFRF+PjIWIBAeMhQgHhwwPhg+Pj4////4+UT2AAAAAF0Uk5TAEDm2GYAAABsSURBVBhXXY7RCcNgCIQtdIC2G1TjAsq9l9ANDvdfJfwmFOyBoh/eody/Qx/ZdWiTuauKqtMrnNptAQLJq0UDQ5COSNoJChX0rMDPgqhaB5fFz4zlawD2nJVgA0uLXBWWnfH32Gvub7k9hx4HZKYop2kQn8IAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Grass.png
// module id = 166
// module chunks = 0